import styled from 'styled-components';

export const TitleResult = styled.h1`
    font-weight: 400;
    font-size: 16px;
`;
